angular.module('unergie.main')
.filter('camundaUrl', (BoFeaturesService) => {
    const urls = {
        int: 'https://camunda.int.unergie.com',
        preprod: 'https://camunda.preprod.unergie.com',
        prod: 'https://camunda.unergie.com',
    }
    const url = urls[BoFeaturesService.getEnv()]
    return function (val, search) {
        if (!search) {
            return `${url}/camunda/app/tasklist/default/#/?task=${val}`
        }
        return `${url}/camunda/app/tasklist/default/#/?searchQuery=[{"type":"processVariables","operator":"eq","value":"${val}","name":"${search}"}]`
    }
})
